module.exports = __webpack_public_path__ + "static/media/temporal.d43f4e8e.png";